const translations = {
    lastActivity: 'Last Activity',
    lastEdited: 'Last Edited',
    loading: 'Loading...',
    name: 'Name',
    noMoreApplications: 'No more applications'
};

export default translations;
